<template>
  <button
    class="poppins relative inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-lg font-medium rounded-xl text-white bg-alo-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-alo-400"
    :class="{ 'hover:bg-alo-400': !loading, 'cursor-not-allowed': loading }"
    :disabled="loading"
  >
    <span
      v-if="loading"
      class="absolute top-0 right-0 bottom-0 left-0 bg-alo-600 rounded-md flex items-center justify-center"
      :class="{ 'hover:bg-alo-700': !loading }"
    >
      <Spinner />
    </span>
    <slot />
  </button>
</template>

<script>
import Spinner from '@/Shared/Components/Spinner.vue'

export default {
  components: { Spinner },

  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
